import { render, staticRenderFns } from "./LegoCircularProgress.vue?vue&type=template&id=a2d9d9f6&scoped=true"
import script from "./LegoCircularProgress.vue?vue&type=script&lang=js"
export * from "./LegoCircularProgress.vue?vue&type=script&lang=js"
import style0 from "./LegoCircularProgress.vue?vue&type=style&index=0&id=a2d9d9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d9d9f6",
  null
  
)

export default component.exports